/* eslint-disable comma-dangle */

export default {
  address: ['user-input', 'exact-address', 'map', 'highway', 'underground'],
  'about-object': [
    'business-appointments',
    'price-and-deal-terms/monthly-income',
    'commercial-total-area',
    'business-floor',
    'has-furniture',
    'has-equipment',
  ],
  'price-and-deal-terms': ['price-with-vat', 'vat-type', 'estate-type', 'agent-bonus'],
};
